import { render, staticRenderFns } from "./ModalQuotation.vue?vue&type=template&id=66915ab6&scoped=true&lang=pug"
import script from "./ModalQuotation.vue?vue&type=script&lang=js"
export * from "./ModalQuotation.vue?vue&type=script&lang=js"
import style0 from "./ModalQuotation.vue?vue&type=style&index=0&id=66915ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66915ab6",
  null
  
)

export default component.exports